<main id="main-content" class="h-screen flex flex-col pl-8 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    Functions
                </h1>
                <div data-popover-target="popover-right" data-popover-placement="right" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-right" role="tooltip" class="absolute z-30 invisible inline-block w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2 flex flex-col gap-1">
                        <p>
                            To create a <strong>Function</strong>, click on 
                            <span class="inline-flex px-3 py-1 h-full flex flex-row gap-2 items-center justify-center rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white oswald-font">  
                                <lucide-icon [img]="icons.Plus"></lucide-icon>
                                Add New
                            </span>. In the pop-up, fill out the function name and its corresponding goals and objectives. In the bottom of the page, recommended Functions are provided as well. Once completed, click 
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">
                                Save
                            </span>.
                        </p>
                        <p>
                            To preview a <strong>Function</strong>, click on 
                            <span class="inline-flex px-3.5 py-1 font-normal oswald-font border border-nside-gray-400 bg-white rounded-md">
                                Preview
                            </span>.
                        </p>
                        <p>
                            To edit a <strong>Function</strong>, click on 
                            <span class="px-3.5 py-1 inline-flex font-normal text-white oswald-font border border-nside-orange-300 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 cursor-pointer">
                                Edit
                            </span>.
                        </p>
                        <p>
                            To delete a <strong>Function</strong>, click on 
                            <span class="inline-flex px-3.5 py-1 font-normal text-white oswald-font border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md"
                            >
                                Delete
                            </span>. Remember, once a <strong>Function</strong> is deleted, it cannot be restored.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
            <eop-assistant
                [sectionId]="sectionTypeId"
            ></eop-assistant>          
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-col items-start gap-8 overflow-y-auto">
        <div class="max-h-full w-full flex flex-col gap-4">
            <div class="h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col items-center justify-between p-6 gap-4 overflow-y-auto">
                <div class="w-full h-fit flex itesm-center justify-between">
                    <h3 class="oswald-font text-xl font-medium">Functions</h3>
                    <button 
                        *ngIf="canSave()"
                        (click)="$event.preventDefault(); handleOpenModal('new-function');"
                        class="px-4 py-2 h-full flex flex-row gap-2 items-center justify-center px-4 py-2 rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400  hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white oswald-font"
                    >  
                        <lucide-icon [img]="icons.Plus"></lucide-icon>
                        Add New
                    </button>
                </div>
                <div class="w-full h-full flex flex-col itesm-center overflow-y-auto divide-y">
                    <ng-container *ngIf="functionsList.length > 0; else emptyThreat">
                        <div 
                            class="w-full h-full flex items-center justify-between py-2"
                            *ngFor="let item of functionsList"
                        >
                            <p class="max-w-[70%] whitespace-pre-line break-words overflow-hidden text-start">
                                {{ item.function_name }}
                            </p>
                            <div class="w-full max-w-[30%] flex items-center justify-end gap-2">
                                <button 
                                    (click)="$event.preventDefault(); handleOpenModal('function-details', item);"
                                    class="w-full max-w-20 py-2 font-normal oswald-font border border-nside-gray-400 bg-white rounded-md hover:bg-gray-100 cursor-pointer"
                                >
                                    Preview
                                </button>
                                <button 
                                    *ngIf="canSave()"
                                    (click)="$event.preventDefault(); handleOpenModal('edit-function', item);"                                
                                    class="w-full max-w-20 py-2 font-normal text-white oswald-font border border-nside-orange-300 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 cursor-pointer"
                                >
                                    Edit
                                </button>
                                <button 
                                    *ngIf="canSave()"
                                    (click)="$event.preventDefault(); handleOpenModal('delete-confirmation', item);"
                                    class="w-full max-w-20 py-2 font-normal text-white oswald-font border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 cursor-pointer"
                                >
                                    Delete
                                </button>
                            </div>
                        </div>

                    </ng-container>
                    <ng-template #emptyThreat>
                        <div class="text-nside-gray-100 italic text-center">
                            Empty list
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="canSave()" class="w-full">
        <function-suggestion
            (suggestionClick)="handleOpenModal('function-suggestion', $event)"
        ></function-suggestion>
    </div>

    <introduction></introduction>
    
    <function-details
        *ngIf="showFunctionDetails"
        [functionDetails]="selectedFunction"
        (onClose)="handleCloseModal('function-details')"
    ></function-details>

    <new-function
        *ngIf="showAddNewFunction"
        [functionName]="suggestedFunctionName"
        (onClose)="handleCloseModal('new-function')"
        (onSave)="handleSave($event, 'new-function')"
    ></new-function>

    <function-edit
        *ngIf="showFunctionEdit"
        [functionToEdit]="selectedFunction"
        (onClose)="handleCloseModal('edit-function')"
        (onSave)="handleSave($event, 'edit-function')"
    ></function-edit>

    <delete-confirmation
        *ngIf="showDeleteConfirmation"
        [text]="'this function'"
        [itemToDelete]="selectedFunction"
        (onClose)="handleCloseModal('delete-confirmation')"
        (onDelete)="handleDelete($event)"
    ></delete-confirmation>

    <prv-next-buttons [totalPages]="(eopNavigationService.totalPages$ | async) || []" />

    <popup-message 
        [type]="messageModal"
        [message]="popupMessage"
        (close)="resetMessageModal()"
    ></popup-message>

    <div *ngIf="loading">
        <spinner></spinner>
    </div>
</main>